import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import EditIcon from '@material-ui/icons/Edit';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { t } from 'src/lib/language';
import { useEffect } from 'react';
import { setSelections } from 'src/redux/actions/selectionActions';
import { ENTITIES } from 'src/models/QuerybuilderModel';

interface Props {
  paymentId?: string | number;
}

const EditPaymentButton = (props: ButtonProps & Props) => {
  const dispatch = useAppDispatch();
  const { disabled } = props;
  const lang = useSelector((state: Store) => state.language.language);
  const { paymentId } = props;

  useEffect(() => {
    if (paymentId) {
      dispatch(setSelections({
        entity: ENTITIES.payments,
        selections: [paymentId],
      }));
    }
  }, []);

  const handleOpen = () => {
    dispatch(openModal({ modal: MODALS.editPayment }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.edit_selected')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.action}
            onClick={handleOpen}
            disabled={disabled}>
            <EditIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default EditPaymentButton;
